import React from 'react';

interface CheckboxProps {
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  name: string;
  id?: string;
}

const Checkbox = ({ checked, onChange, label, name, id }: CheckboxProps) => {
  return (
    <label htmlFor={id || name} className="flex items-start cursor-pointer">
      <div className="relative flex items-center pt-0.5">
        <input
          id={id || name}
          checked={checked}
          type="checkbox"
          name={name}
          onChange={onChange}
          className="sr-only peer"
        />
        <div className="h-5 w-5 border-2 rounded mr-2 peer-checked:bg-primary peer-checked:border-primary peer-checked:border-4 peer-checked:border-double flex justify-center items-center hover:border-primary/50">
          {checked && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-3.5 w-3.5 text-primary-foreground"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
          )}
        </div>
      </div>
      <span className="text-sm">{label}</span>
    </label>
  );
};

export default Checkbox;
